import { Object, Optional, Static, String, Array, Record, Number, Boolean } from '@sinclair/typebox';

import { RetrieveReservationDictionary } from '../dapi';
import { DapiError, DapiWarning } from '../dapi/common';

import { ConfirmationBoundFlightSummary, ConfirmationOrder } from './confirmation';

export const RebookAlternativeOfferRequestBody = Object({
  pnr: String(),
  lastName: String(),
  alternativeOutboundOfferId: String(),
  alternativeInboundOfferId: String(),
  reservationId: String(),
});

export type RebookAlternativeOfferRequestBody = Static<typeof RebookAlternativeOfferRequestBody>;

export const ConfirmationStatusRequestBody = Object({
  pnr: String(),
  lastName: String(),
  alternativeOfferConfJobId: String(),
  isRoundTrip: Boolean(),
});

export type ConfirmationStatusRequestBody = Static<typeof ConfirmationStatusRequestBody>;

export const ConfirmAlternativeOfferResponse = Object({
  data: Object({
    id: String(),
    status: String(),
    pnr: String(),
  }),
  errors: Optional(Array(DapiError)),
  warnings: Optional(Array(DapiWarning)),
});

export type ConfirmAlternativeOfferResponse = Static<typeof ConfirmAlternativeOfferResponse>;

export const ConfirmationResponse = Object({
  status: String(),
});

export type ConfirmationResponse = Static<typeof ConfirmationResponse>;

export const ConfirmationStatusResponse = Object({
  confirmationJobId: String(),
  status: String(),
});

export type ConfirmationStatusResponse = Static<typeof ConfirmationStatusResponse>;

export const MappedOrderResponse = Object({
  status: String(),
  outbound: Optional(ConfirmationBoundFlightSummary),
  inbound: Optional(ConfirmationBoundFlightSummary),
  passengerCount: Record(String(), Number()),
});

export type MappedOrderResponse = Static<typeof MappedOrderResponse>;

export const ConfirmationStatusDapiResponse = Object({
  data: Optional(
    Object({
      id: String(),
      status: String(),
      rebookingStatus: String(),
      reissuanceStatus: String(),
      reaccpetanceStatus: String(),
    })
  ),
  dictionaries: Optional(RetrieveReservationDictionary),
  included: Optional(
    Object({
      orders: Array(ConfirmationOrder),
    })
  ),
  errors: Optional(Array(DapiError)),
  warnings: Optional(Array(DapiWarning)),
});

export type ConfirmationStatusDapiResponse = Static<typeof ConfirmationStatusDapiResponse>;

export const ConfirmAlternativeOfferDapiResponse = Object({
  data: Object({
    id: String(),
    status: String(),
  }),
  errors: Optional(Array(DapiError)),
  warnings: Optional(Array(DapiWarning)),
});

export type ConfirmAlternativeOfferDapiResponse = Static<typeof ConfirmAlternativeOfferDapiResponse>;
